module.exports = __webpack_public_path__ + "img/radio-buttons-example.8c36639e.svg";